import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import './lib/i18n';

import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NewsList from './pages/NewsList';
import NewsForm from './pages/NewsForm';
import ProductList from './pages/ProductList';
import ProductForm from './pages/ProductForm';
import ServiceList from './pages/ServiceList';
import ServiceForm from './pages/ServiceForm';
import NewsCardList from './pages/NewsCardList';
import NewsCardForm from './pages/NewsCardForm';
import ServiceCardList from './pages/ServiceCardList';
import ServiceCardForm from './pages/ServiceCardForm';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-background">
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />
              
              {/* Protected Routes */}
              <Route path="/*" element={
                <ProtectedRoute>
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      
                      {/* News Routes */}
                      <Route path="/news" element={<NewsList />} />
                      <Route path="/news/create" element={<NewsForm />} />
                      <Route path="/news/edit/:id" element={<NewsForm />} />
                      
                      {/* Products Routes */}
                      <Route path="/products" element={<ProductList />} />
                      <Route path="/products/new" element={<ProductForm />} />
                      <Route path="/products/:id/edit" element={<ProductForm />} />
                      <Route path="/products/:id" element={<ProductForm />} />
                      
                      {/* Services Routes */}
                      <Route path="/services" element={<ServiceList />} />
                      <Route path="/services/new" element={<ServiceForm />} />
                      <Route path="/services/:id/edit" element={<ServiceForm />} />
                      <Route path="/services/:id" element={<ServiceForm />} />
                      
                      {/* News Cards Routes */}
                      <Route path="/news-cards" element={<NewsCardList />} />
                      <Route path="/news-cards/new" element={<NewsCardForm />} />
                      <Route path="/news-cards/:id/edit" element={<NewsCardForm />} />
                      <Route path="/news-cards/:id" element={<NewsCardForm />} />
                      
                      {/* Service Cards Routes */}
                      <Route path="/service-cards" element={<ServiceCardList />} />
                      <Route path="/service-cards/new" element={<ServiceCardForm />} />
                      <Route path="/service-cards/:id/edit" element={<ServiceCardForm />} />
                      <Route path="/service-cards/:id" element={<ServiceCardForm />} />
                    </Routes>
                  </Layout>
                </ProtectedRoute>
              } />
            </Routes>
            <Toaster position="top-right" />
          </div>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
